module.exports = __webpack_public_path__ + "img/transmaes_logo_big.2bd939d3.svg";